import React, {PropTypes} from 'react';
import DataTable from "../../../DataTable";
import {inject, observer} from 'mobx-react';
import {observable, action, toJS} from 'mobx';
import Spinner from "../../../Spinner";

@inject('ticketStatusStore')
@observer
class StatusList extends React.Component {

  static propTypes = {
    params: PropTypes.shape().isRequired,
    route: PropTypes.shape().isRequired,
    children: PropTypes.node,
  };

  slug = 'monitoring/config/status';
  statusColumn = [
    {key: 'id', label: 'Id'},
    {key: 'caption', label: 'Caption'},
    {key: 'description', label: 'Description'},
    {key: 'color', label: 'Color'},
  ];

  handleDelete = (idOrIds) => {
    console.log('handleDelete', idOrIds);
    this.props.ticketStatusStore.removeItems(idOrIds);
  };

  render() {
    const {ticketStatusStore} = this.props;
    let data = ticketStatusStore.items.map(({id, caption, description, color}) => ({
      id,
      caption,
      description,
      color: <svg viewBox="0 0 20 20" x="10" width="20">
        <circle cx="10" cy="10" r="8" stroke="grey" strokeWidth="0.5px" fill={color} />
      </svg>
      // color: <i className='fa fa-circle' style={{color}}/>
    }));
    return (
      <div>
        <DataTable data={data} slug={this.slug} columns={this.statusColumn} onDelete={this.handleDelete}
                   allowAdd
                   allowEdit
                   allowDelete
                   resource='maintenance'
        />
        {ticketStatusStore.isLoading && <Spinner/>}
        {this.props.children}
      </div>
    );
  }
}

export default StatusList;



// WEBPACK FOOTER //
// ./src/components/Maintenance/Configuration/Status/StatusList.js